import { makeStyles } from '@material-ui/core'
import { BASE_COLORS } from 'asterX-UI/colors.constant'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'

export const useModalStyles = makeStyles(theme => ({}))

export const useInfoModalStyles = makeStyles(theme => ({
  paper: {
    color: BASE_COLORS.White,
    backgroundColor: props => {
      const { variant } = props
      const [info, warning, error, success] = MODAL_STYLES.variant
      if (variant === info) {
        return theme.palette.allInfo[400]
      }
      if (variant === warning) {
        return theme.palette.allWarning[600]
      }
      if (variant === error) {
        return theme.palette.allError[600]
      }
      if (variant === success) {
        return theme.palette.allSuccess[600]
      }
      return BASE_COLORS.White
    }
  }
}))

export const modalTitleIconedStyles = theme => ({
  root: {
    margin: 0,
    position: 'relative',
    padding: '12px 12px 6px 12px',
    display: 'flex',

    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  modalTitle: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  title: {
    fontWeight: 600
  },
  icon: { display: 'flex', alignItems: 'center' },
  closeButton: {}
})

export const modalTitleStyles = theme => ({
  root: {
    margin: 0,
    position: 'relative',
    padding: '12px 12px 6px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  closeButton: {}
})
